import { FC, PropsWithChildren } from 'react'

import { Sidebar } from './components/Sidebar/Sidebar'

type TProps = {} & PropsWithChildren

const ProfileLayout: FC<TProps> = ({ children }) => {
  return (
    <div className="relative flex min-h-full w-full items-center overflow-hidden bg-palette-black pl-96 pr-12">
      <Sidebar />
      <div className="flex flex-col w-full h-full relative">
        <main className="relative rounded-2xl flex flex-1 flex-col bg-white my-12">{children}</main>
      </div>
    </div>
  )
}

export { ProfileLayout }
